export var BNWASContent;
(function (BNWASContent) {
    BNWASContent["Activate"] = "Activate";
    BNWASContent["Deactivate"] = "Deactivate";
})(BNWASContent || (BNWASContent = {}));
//# sourceMappingURL=BNWASContent.js.map